/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { Button, Chips, ContentCard } from 'ypf-pas-general-ui-components';
import { Col, Row } from 'react-bootstrap';

import { stepEnum, stepEnumOfAccordion } from '../Constants';
import { RequestErrors, RequestField, RequestTouched, RequestValue } from '../CreateServiceProps';
import ApproverFormSelect from '../../ApproverForm/ApproverFormSelect';
import useAssociatedUsersForm from '../../ApproverForm/useAssociatedUsersForm';
import Communicate from '../Communicate';
import { useAppContext } from '../../../context/AppProvider';

const AssociatedUsersContainer = (props) => {
  const {
    accordionIndex,
    isApplyTemplateRequest,
    imptationObjectWells,
    serviceId,
    setStep,
    step,
    ubicationTeamValue,
    ubicationTypeId,
    requestField,
    requestValue,
    requestErrors,
    requestTouched,
    isDraft,
    disabledAllFields
  } = props;

  const { userInfo } = useAppContext();

  const { values, setFieldValue, setFieldTouched } = useFormikContext();

  const containerRef = useRef();

  const associatedUsersField = `accordions[${accordionIndex}].associatedUsers`;
  const associatedUsersValue = values?.accordions[accordionIndex]?.associatedUsers;

  const { getOptionApprover, approverOptions, getInspectorsOptions } = useAssociatedUsersForm({
    requestValue,
    serviceId,
    ubicationTypeId,
    ubicationTeamValue,
    imptationObjectWells,
    associatedUsersValue,
    associatedUsersField
  });

  const isApproverInvalid =
    requestErrors?.associatedUsers?.approvers && requestTouched?.associatedUsers?.approvers;

  const isButtonContinueDisabled =
    !!requestErrors?.associatedUsers?.approvers || !!requestErrors?.associatedUsers?.inspectors;

  useEffect(() => {
    if (step === stepEnumOfAccordion.associatedUsers || isApplyTemplateRequest) {
      containerRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      setFieldValue(`${requestField}.accordionStep`, stepEnumOfAccordion.associatedUsers);
      getOptionApprover();
      getInspectorsOptions();
    }
  }, [step]);

  useEffect(() => {
    if (isDraft && step > stepEnumOfAccordion.associatedUsers) getOptionApprover();
  }, []);

  return (
    <div ref={containerRef}>
      <ContentCard
        mark={
          values.currentStep >= stepEnum.services && step === stepEnumOfAccordion.associatedUsers
            ? 'primary'
            : 'none'
        }
        orientation="horizontal-vertical"
      >
        <Row className="mt-3">
          <Col sm={12}>
            <ApproverFormSelect
              errors={requestErrors?.associatedUsers?.approvers}
              isDisabled={disabledAllFields}
              isInvalid={isApproverInvalid}
              name={`${associatedUsersField}.approvers`}
              onChange={(val) => {
                setFieldValue(`${associatedUsersField}.approvers`, val);
                setFieldTouched(`${associatedUsersField}.approvers`);
                setStep(stepEnumOfAccordion.associatedUsers);
              }}
              options={approverOptions}
              value={associatedUsersValue?.approvers}
            />
          </Col>
        </Row>
        <div className="d-flex align-items-center mb-4">
          <h6 className="me-3 mb-0">Inspector:</h6>
          <Chips data={associatedUsersValue?.inspectors} variant="info" />
        </div>
        <div className="d-flex align-items-center mb-4">
          <h6 className="me-2 mb-0">Solicitante:</h6>
          <Chips data={[{ label: userInfo.name }]} variant="info" />
        </div>
        <Row className="mt-3">
          <Col sm={12}>
            <Communicate
              accordionIndex={accordionIndex}
              disabledAllFields={disabledAllFields}
              requestErrors={requestErrors}
              requestField={requestField}
              requestTouched={requestTouched}
              requestValue={requestValue}
              setStep={setStep}
            />
          </Col>
        </Row>
        {step === stepEnumOfAccordion.associatedUsers && (
          <>
            <hr />
            <div className="gap row justify-content-end">
              <Button
                label="Cancelar"
                onClick={() => {
                  setFieldValue(`${associatedUsersField}.approvers`, []);
                  setFieldValue(`${associatedUsersField}.inspectors`, []);
                  setFieldValue(`${associatedUsersField}.aditionalReceivers`, []);
                  setFieldValue(`${associatedUsersField}.receivers`, []);
                  setStep(stepEnumOfAccordion.provider);
                }}
                type="button"
                variant="outline-primary"
              />
              <Button
                disabled={isButtonContinueDisabled}
                label="Continuar"
                onClick={() => setStep(stepEnumOfAccordion.files)}
                type="button"
                variant="primary"
              />
            </div>
          </>
        )}
      </ContentCard>
    </div>
  );
};

AssociatedUsersContainer.propTypes = {
  accordionIndex: PropTypes.number.isRequired,
  disabledAllFields: PropTypes.bool,
  serviceId: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  imptationObjectWells: PropTypes.arrayOf(PropTypes.shape({})),
  isApplyTemplateRequest: PropTypes.bool,
  ubicationTeamValue: PropTypes.number.isRequired,
  ubicationTypeId: PropTypes.number.isRequired,
  requestErrors: RequestErrors,
  requestField: RequestField.isRequired,
  requestTouched: RequestTouched.isRequired,
  requestValue: RequestValue.isRequired,
  isDraft: PropTypes.bool.isRequired
};

AssociatedUsersContainer.defaultProps = {
  disabledAllFields: false,
  imptationObjectWells: [],
  isApplyTemplateRequest: false,
  requestErrors: {}
};

export default AssociatedUsersContainer;
